import React, { type ReactElement } from 'react'
import { Typography } from '@mui/material'
import verificationBackground from 'assets/verificationBackground.svg'
import theme from 'common/utils/theme'
import { ReactComponent as InfoIcon } from 'assets/infoIcon.svg'

import { type VendorStatus } from '../vendor.types'
import { statusColors, statusMessage } from '../vendor-profile-layout/VendorProfileLayout'

import styles from './Verification.module.scss'

interface VerificationProcessProps {
  status: VendorStatus
  text: string
  additionalContent?: React.ReactNode
}

const Verification: React.FC<VerificationProcessProps> = ({
  status,
  text,
  additionalContent,
}): ReactElement => {
  return (
    <div
      className={styles.infoWrapper}
      style={{
        backgroundImage: `url(${verificationBackground})`,
      }}
    >
      <div className={styles.content}>
        <div className={styles.textWrapper}>
          Vaš nalog je aktiviran i sada je potrebno da admin verifikuje vašu firmu. U informativnom prozoru
          ispod možete videti Vaš status verifikacije.
        </div>
        <div className={styles.statusWrapper}>
          <div className={styles.status}>
            <InfoIcon width={24} height={24} fill={statusColors(status, theme.palette)} />
            <Typography variant="title2" sx={{ paddingLeft: '10px' }}>
              Vaš status -{' '}
            </Typography>
            <Typography
              variant="title2"
              sx={{
                color: statusColors(status, theme.palette),
                paddingLeft: '5px',
              }}
            >
              {statusMessage(status)}
            </Typography>
          </div>
          <div className={additionalContent ? styles.textStatusColumnWrapper : styles.textStatusWrapper}>
            <div className={styles.text}>
              <Typography variant="title2" sx={{ color: theme.palette.gray.main }}>
                {text}
              </Typography>
            </div>
            {additionalContent && <div>{additionalContent}</div>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Verification
